import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { Input } from "../../../editor/Input";
import { isBlank } from "../../../../../shared/helper/generalHelpers";
import { ElementGroup, ElementLabel } from './BaseElements';
export const StringActionDetail = observer(({
  name,
  value,
  valueSetter,
  disabled,
  allowBlankValue
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, name), /*#__PURE__*/React.createElement(Input, {
    className: !allowBlankValue && isBlank(value) ? "invalid" : "",
    type: "text",
    disabled: disabled,
    value: value,
    onChange: ({
      target
    }) => valueSetter(target.value)
  }));
});